
<!-- <h2 mat-dialog-title>Edit {{data.file_version}} <mat-icon>cloud_download</mat-icon></h2> -->
<h2 mat-dialog-title>Edit {{data.file_version}} <a href="{{data.down_link}}" target="_blank"><mat-icon>cloud_download</mat-icon></a></h2>
<!-- Other content remains unchanged -->

<mat-dialog-content *ngIf="data">
	<!-- <form [formGroup]="editForm"> -->
		<p>
			<kt-searchable-select
				class="example-form-small"
				label="Select Mode"
				[options]="modeOptions"
				[multiple]="false"
				[searchable]="false"
				[formControl]="modeSelect">
			</kt-searchable-select>
		</p>
		<div *ngIf="modeSelect.hasError('required') && modeSelect.touched" class="mat-error">You must select a mode</div>

		<p>
			<mat-form-field class="example-form">
				<mat-label>Description</mat-label>
				<textarea rows="2" matInput [formControl]="desc"></textarea>
			</mat-form-field>
		</p>

		<div *ngIf="data.file_type !== 'ui'" class="row mb-2">
			<div class="col-xl-6 col-sm-12 mt-1">
				<mat-card>
					<mat-card-header>
						<mat-card-subtitle>Compatible UIs</mat-card-subtitle>
					</mat-card-header>
					<mat-card-content style="height: 150px;">
						<mat-chip-list>
							<mat-chip *ngFor="let chip of compVersions" selected="true" (click)="removeCompVersion(chip)" color="primary">
							  {{chip}}
							  <mat-icon matChipRemove style="color: red;" (click)="removeCompVersion(chip)">remove_circle</mat-icon>
							</mat-chip>
						  </mat-chip-list>
					</mat-card-content>
				</mat-card>

			</div>
			<div class="col-xl-6 col-sm-12 mt-1">
				<mat-card>
					<mat-card-header>
						<mat-card-subtitle>In-Compatible UIs</mat-card-subtitle>
					</mat-card-header>
					<mat-card-content style="height: 150px;">
						<mat-chip-list>
							<mat-chip *ngFor="let chip of availableVersions" (click)="addCompVersion(chip)" selected="false">
							  {{chip}}
							  <mat-icon matChipRemove style="color: green;" (click)="addCompVersion(chip)">add_circle</mat-icon>
							</mat-chip>
						  </mat-chip-list>
					</mat-card-content>
				</mat-card>
			</div>
		</div>
	<!-- </form> -->

</mat-dialog-content>
<br>
<mat-dialog-actions>
	<div class="col-lg-12 text-right">
		<button type="button" mat-raised-button [mat-dialog-close]="data.animal" cdkFocusInitial>
			Cancel
		</button>&nbsp;
		<button type="button" mat-raised-button
			color="primary" (click)="submitForm()">
			Save
		</button>
	</div>

</mat-dialog-actions>





